import { ca } from '@cian/analytics';

export function trackEachAppearance() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'show_sopr',
    label: 'airphoto',
    useLastProducts: true,
  });
}
